var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AuthCard',[(_vm.twoFactorEmail)?_c('div',[_c('h2',[_vm._v("Login")]),_c('p',[_vm._v(" Use your authenticator app to generate a security code for the login. ")]),_c('TwoFactorForm',{attrs:{"loading":_vm.loading},on:{"submit":_vm.submitTwoFactor}})],1):_c('CredentialsForm',{attrs:{"loading":_vm.loading},on:{"submit":_vm.submitLogin}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }